import { ReactNode, useMemo } from 'react';
import { UseFormRegister } from 'react-hook-form';

import Tooltip from '@components/Tooltip';

type PropsTypes = {
  checkboxState: boolean;
  setCheckboxState: (arg0: boolean) => void;
  register?: UseFormRegister<any>;
  title: ReactNode;
  content: ReactNode;
  required?: boolean;
  inputRef?: any;
  name?: string;
};

const Agreement = ({
  checkboxState,
  setCheckboxState,
  title,
  register,
  inputRef,
  content,
  name,
  required = false,
}: PropsTypes) => {
  const props = useMemo(() => {
    if (register && name) {
      return register(name);
    }

    return {
      onChange: () => setCheckboxState(!checkboxState),
      ref: inputRef,
      name,
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [register]);

  const titleComponent = (
    <>
      <input
        type="checkbox"
        required={required}
        className="mr-1.5"
        checked={checkboxState}
        {...props}
      />
      {title}
    </>
  );

  return (
    <div className="form-group">
      <label>
        <Tooltip
          title={titleComponent}
          content={content}
          timeout={50}
          tooltipClassName="text-xs"
          forceClose="mobile"
        />
      </label>
    </div>
  );
};

export default Agreement;
